(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSMovimientoEstatusProyecto', SSMovimientoEstatusProyecto);

    SSMovimientoEstatusProyecto.$inject = ['$resource', 'DateUtils'];

    function SSMovimientoEstatusProyecto ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-movimiento-estatus-proyectos/:id';

        return $resource(resourceUrl, {}, {
            'query': { 
            	method: 'GET', 
            	isArray: true
          	},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fechaMovimiento = DateUtils.convertDateTimeFromServer(data.fechaMovimiento);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
            'getByProyecto': {
                method: 'GET',
                isArray: true,
                url:'api/s-s-movimiento-estatus-proyectos/proyecto/:idProyecto',
            },            
            'update': { method:'PUT' },
            'create': { 
            	method:'POST', 
                url:'api/s-s-movimiento-estatus-proyectos/proyecto',
            },
            'hasBeenRegistered': {
                method: 'GET',
                isArray: false,
                url:'api/s-s-movimiento-estatus-proyectos/hasBeenRegistered/:idProyecto',
                transformResponse: function (data) {
                    return {boolean: angular.fromJson(data)};
                }
            },
        });
    }
})();
